export const useThemeStore = defineStore('theme', {
  state: () => ({
    theme: null,
  }),
})
